import React, { useCallback, useState } from 'react';
import { Link } from 'gatsby';
import { FiAlertCircle } from 'react-icons/fi';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import * as yup from 'yup';

import { RiInformationFill } from 'react-icons/ri';

import Input from '../../Input/Input';
import Button from '../../Button';

import { useRegister } from '../../../hooks/register';

import {
  BackgroundImageBottom, Content, BackgroundImageTop, Container, Logo
} from '../../../pages/register/styles';
import { Form } from './styles';
import { ErrorMessage } from '../../../styles/globalStyled';
import Tooltip from '../../Tooltip';
import { BgImage } from '../../Sections/InfoSection/styles';

export const RegisterForm: React.FC = () => {
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [admissionDate, setAdmissionDate] = useState('');
  const [touched, setTouched] = useState(false);
  const {handleValidateLasaUser, loading} = useRegister();

  const dateValidation = yup
    .string()
    .required()
    .test('validDate', 'invalid date', (value) => moment(value, 'DD / MM / YYYY', true).isValid());

  const formValidation = yup.object().shape({
    registrationNumber: yup.string().required(),
    birthDate: dateValidation,
    admissionDate: dateValidation,
  });

  const formIsValid = () => formValidation.isValidSync({registrationNumber, admissionDate, birthDate});

  const onSubmit = useCallback(
    async (event: any) => {
      event.preventDefault();
      setTouched(true);

      if (formIsValid()) {
        handleValidateLasaUser({
          registrationNumber,
          admissionDate: moment(admissionDate, 'DD / MM / YYYY').format('YYYYMMDD'),
          birthDate: moment(birthDate, 'DD / MM / YYYY').format('YYYYMMDD'),
        });
      }
    },
    [admissionDate, registrationNumber, birthDate],
  );

  return (
    <Content>
      <BgImage image="img/signup-bg.svg" right="0px" top="0px" width={203} height={50} />
      <BgImage image="img/signup-bg7.svg" left="0px" top="0px" width={130} height={130} showOnMobile />
      <BgImage image="img/signup-bg3.svg" right={77} top={150} width={49} height={48} />
      <BgImage image="img/signup-bg5.svg" right="0px" bottom="0px" width={131} height={130} />
      <BgImage image="img/signup-bg2.svg" right={130} bottom={160} width={114} height={80} />
      <BgImage image="img/signup-bg6.svg" left="0px" bottom="0px" width={283} height={97} />
      <BgImage image="img/signup-bg4.svg" left={119} bottom={153} width={204} height={165} />

      <ReactTooltip />
      <Container>
        <Link to="/">
          <Logo src="img/logo-allya.svg" alt="allya" />
        </Link>
        <h1>Cadastre-se e comece a utilizar seus benefícios</h1>
        <h2>
          Preencha com seus dados abaixo para se cadastrar
          <Tooltip
            text="Os dados abaixo serão utilizados apenas para consulta e acesso a base de benefícios da empresa, logo a Allya não vai armazenar estes dados.">
            <RiInformationFill />
          </Tooltip>
        </h2>

        <Form onSubmit={onSubmit} disabled={loading}>
          <Input
            name="prontuario"
            type="text"
            inputMode="numeric"
            placeholder="Prontuário"
            value={registrationNumber}
            tooltip="O código do prontuário pode ser encontrado no seu crachá corporativo."
            onChangeValue={setRegistrationNumber}
            invalid={touched && !formValidation.fields?.registrationNumber.isValidSync(registrationNumber)}
          />

          <Input
            name="birthDate"
            inputMode="numeric"
            type="text"
            placeholder="Data de Nascimento"
            value={birthDate}
            onChangeValue={setBirthDate}
            mask="99 / 99 / 9999"
            invalid={touched && !formValidation.fields?.birthDate.isValidSync(birthDate)}
          />

          <Input
            name="admissionDate"
            inputMode="numeric"
            type="text"
            placeholder="Data de Admissão"
            tooltip="Sua data de admissão pode ser encontrada no seu crachá corporativo."
            value={admissionDate}
            onChangeValue={setAdmissionDate}
            mask="99 / 99 / 9999"
            invalid={touched && !formValidation.fields?.admissionDate.isValidSync(admissionDate)}
          />

          <ErrorMessage visibility={touched && !formIsValid() ? 1 : 0}>
            <FiAlertCircle size={20} />
            Preencha corretamente os campos acima
          </ErrorMessage>
          <Button
            loading={loading}
            disabled={loading}
            title="Continuar"
            classType={`big fat orange center ${!formIsValid() ? 'disabled' : ''}`}
            type="submit"
          />

          <Link to="/">
            <Button disabled={loading} title="Voltar" classType="big fat orange center outline" type="button" />
          </Link>
        </Form>
      </Container>
    </Content>
  );
};

export default RegisterForm;
